import AncillaryReportRoute from './pages/AncillaryReport/AncillaryReport.route'
import ApplicationQueueRoutes from './pages/ApplicationQueue/ApplicationQueue.route'
import BenchmarkPlansRoute from './pages/BenchmarkPlans/BenchmarkPlans.route'
import BenefitIntegrationsRoutes from './pages/BenefitIntegrations/routes'
import CensusManagementRoutes from './pages/CensusManagement/CensusManagement.route'
import CustomerRoutes from './pages/CustomerManagement/routes'
import CensusOnboardingRoute from './pages/CustomerOnboarding/CustomerOnboarding.route'
import DemoCompanyManagementRoutes from './pages/DemoCompanyManagement/DemoCompanyManagement.route'
import EnrollmentOverlapRoute from './pages/EnrollmentOverlap/EnrollmentOverlap.route'
import FinanceRoutes from './pages/finance/finance.routes'
import FundingInvoiceRoutes from './pages/FundingInvoice/funding-invoice.routes'
import HRISRoutes from './pages/HRIS/hris.routes'
import NewHomeRoute from './pages/NewHome/NewHome.route'
import PlanManagementRoutes from './pages/PlanManagement/PlanManagement.route'
import PlanManagementV2Routes from './pages/PlanManagementV2/PlanManagementV2.route'
import PlanManagementV3Routes from './pages/PlanManagementV3/PlanManagementV3.route'
import AccessControlRoute from './pages/AccessControl/AccessControl.route'
import SettingsRoutes from './pages/Settings/settings.routes'
import SharePointRoute from './pages/SharePoint/SharePoint.route'

export default function getRoutes() {
  return [
    CustomerRoutes,
    DemoCompanyManagementRoutes,
    EnrollmentOverlapRoute,
    NewHomeRoute,
    ...CensusManagementRoutes,
    ...PlanManagementRoutes,
    ...PlanManagementV2Routes,
    ...PlanManagementV3Routes,
    ...ApplicationQueueRoutes,
    BenefitIntegrationsRoutes,
    BenchmarkPlansRoute,
    AncillaryReportRoute,
    HRISRoutes,
    FinanceRoutes,
    FundingInvoiceRoutes,
    CensusOnboardingRoute,
    SettingsRoutes,
    AccessControlRoute,
    SharePointRoute,
  ]
}
